/** Public-facing labels (backend plan `name` stays free/starter/professional/enterprise). */
export const PUBLIC_PLAN_LABELS = {
  free: 'Free plan',
  starter: 'Basic Plan',
  professional: 'Premium Plan',
  enterprise: 'Enterprise Plan',
};

export const PLAN_DISPLAY_ORDER = ['free', 'starter', 'professional', 'enterprise'];

export function publicPlanLabel(planOrName) {
  const name = typeof planOrName === 'string' ? planOrName : planOrName?.name;
  if (!name) return 'Plan';
  const key = name.toLowerCase();
  return PUBLIC_PLAN_LABELS[key] || planOrName?.display_name || name;
}

export function sortPlansForDisplay(plans) {
  return [...plans].sort((a, b) => {
    const ai = PLAN_DISPLAY_ORDER.indexOf(a.name);
    const bi = PLAN_DISPLAY_ORDER.indexOf(b.name);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });
}

export function getFreePlan(plans) {
  return plans.find((plan) => plan.name === 'free');
}

export function getPaidPlans(plans) {
  return plans.filter((plan) => plan.name !== 'free');
}

export function getDocumentProcessingLabel(planOrName) {
  const name = typeof planOrName === 'string' ? planOrName : planOrName?.name;
  switch (name?.toLowerCase()) {
    case 'free':
      return 'Document Processing (Limited to 5 docs/day)';
    case 'starter':
      return 'Document Processing (Limited to 25 docs/month)';
    case 'professional':
      return 'Document Processing (Limited to 70 docs/month)';
    case 'enterprise':
      return 'Document Processing (Custom Limit/month)';
    default:
      return 'Document Processing';
  }
}

export function getUsageDisplayValues(usage) {
  const isDaily = usage?.limit_period === 'daily';
  return {
    used: isDaily
      ? (usage?.daily_used ?? 0)
      : (usage?.current_month?.total_documents ?? 0),
    limit: isDaily
      ? (usage?.daily_limit ?? 5)
      : (usage?.custom_limit != null ? usage.custom_limit : (usage?.monthly_limit ?? 0)),
    periodLabel: isDaily ? 'today' : 'this month',
    isDaily,
  };
}
